import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { Loader, Message } from 'semantic-ui-react';
import SuccessfulCheckoutConfirmation from '../../domains/checkout/SuccessfulCheckoutConfirmation';
import useQueryParams from '../../hooks/use-queryparams/use-queryparams';
import { getOrder } from '../../utils/api';
var defaultProps = {
  orderId: null,
  useQueryParam: false
};
function OrderConfirmation(_ref) {
  var orderId = _ref.orderId,
    useQueryParam = _ref.useQueryParam;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    orderCart = _useState2[0],
    setOrderCart = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var finalOrderId, cart;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          finalOrderId = orderId;
          if (useQueryParam) {
            finalOrderId = useQueryParams('order_id');
          }
          _context.prev = 2;
          _context.next = 5;
          return getOrder(finalOrderId);
        case 5:
          cart = _context.sent;
          setOrderCart(cart);
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          setErrorMessage('Failed to get order! Please check if you have the right Order ID');
        case 12:
          setLoading(false);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  })), []);
  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, {
      active: true
    });
  }
  if (errorMessage) {
    return /*#__PURE__*/React.createElement(Message, {
      error: true,
      header: errorMessage
    });
  }
  return /*#__PURE__*/React.createElement(SuccessfulCheckoutConfirmation, {
    cart: orderCart
  });
}
OrderConfirmation.defaultProps = defaultProps;
export default OrderConfirmation;